import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Chart from 'react-apexcharts';
import moment from 'moment';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const WeeklyRiskTrend = (props) => {
  const [weeklyRiskStartDate, setWeeklyRiskStartDate] = useState('');
  const [weeklyRiskEndDate, setWeeklyRiskEndDate] = useState('');
  const [weeks, setWeeks] = useState([]);
  const [assessments, setAssessments] = useState([]);
  const [risk, setRisk] = useState([]);

  useEffect(() => {
    if (Object.keys(props.weeklyData).length > 0) {
      const _weeks = Object.keys(props.weeklyData);

      setWeeklyRiskStartDate(
        new Date(moment().week(_weeks[0]).startOf('week').format())
      );

      setWeeklyRiskEndDate(
        new Date(
          moment()
            .week(_weeks[_weeks.length - 1])
            .startOf('week')
            .format()
        )
      );
    }
  }, [props.weeklyData]);

  useEffect(() => {
    weeklyRiskDateFilter();
  }, [weeklyRiskStartDate, weeklyRiskEndDate]);

  const weeklyRiskPlotData = (_weeks) => {
    let _assessments = [];
    let _risk = [];

    for (const week in props.weeklyData) {
      if (_weeks.indexOf(week) > -1) {
        if (props.weeklyData[week].assessment) {
          _assessments = [..._assessments, props.weeklyData[week].assessment];
        } else {
          _assessments = [..._assessments, 0];
        }

        if (props.weeklyData[week].risk) {
          _risk = [..._risk, props.weeklyData[week].risk];
        } else {
          _risk = [..._risk, 0];
        }
      }
    }

    let formattedWeeks = [];

    _weeks.map((week) => {
      formattedWeeks = [
        ...formattedWeeks,
        moment().week(week).startOf('week').format('DD MMM'),
      ];
    });

    setWeeks(formattedWeeks);
    setAssessments(_assessments);
    setRisk(_risk);
  };

  const weeklyRiskDateFilter = () => {
    const startWeek = moment(weeklyRiskStartDate).week();
    const endWeek = moment(weeklyRiskEndDate).week();

    const _weekNumbers = Object.keys(props.weeklyData);

    const _weeks = _weekNumbers.filter(
      (week) => parseInt(week) >= startWeek && parseInt(week) <= endWeek
    );

    weeklyRiskPlotData(_weeks);
  };

  return (
    <div className="card2 card2--line-chart">
      <div className="card2--line-chart__header">
        <div>
          <p className="card2--line-chart__title">Weekly Risk Trend</p>
          <p
            style={{
              fontSize: '1.4rem',
              opacity: '0.5',
            }}
          >
            Based on average of all assesments for the week
          </p>
        </div>
        {/* <div className="card2--line-chart__date">
          <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={weeklyRiskStartDate}
            onChange={(date) => {
              setWeeklyRiskStartDate(date);
            }}
          />
          <p>to</p>
          <DatePicker
            dateFormat="dd/MM/yyyy"
            selected={weeklyRiskEndDate}
            onChange={(date) => {
              setWeeklyRiskEndDate(date);
            }}
          />
        </div> */}
      </div>
      <div className="card2--weekly-chart">
        <Chart
          options={{
            chart: {
              toolbar: {
                show: false,
              },
              fontFamily: 'IBM Plex Sans, sans-serif',
            },
            colors: ['#3ee866', '#f85353'],
            xaxis: {
              categories: weeks,
              title: {
                text: 'Start Date of the Week',
                style: {
                  fontWeight: 'bold',
                },
              },
            },
            dataLabels: {
              enabled: false,
            },
            legend: {
              show: true,
              showForSingleSeries: true,
              showForNullSeries: true,
              position: 'bottom',
              horizontalAlign: 'left',
              fontSize: '13px',
              markers: {
                width: '18px',
                height: '8px',
              },
            },
            tooltip: {
              x: {
                show: false,
              },
            },
          }}
          series={[
            {
              name: 'Assessments',
              data: assessments,
            },
            {
              name: 'High LHI',
              data: risk,
            },
          ]}
          type="area"
          height={'100%'}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  weeklyData: state.analytics.weeklyData,
});

export default connect(mapStateToProps)(WeeklyRiskTrend);
